import { IonCol, IonGrid, IonRow } from '@ionic/react';
import { PropsWithChildren, ReactElement, useCallback, useState } from 'react';
import { useIntl } from 'react-intl';

import TertiaryButton from '@components/buttons/TertiaryButton';
import styles from '@components/SectionWithBanner.module.css';
import Heading2 from '@components/typography/Heading2';
import { clickCurrentTarget } from '@utils/keyboardUtils';

type Props = PropsWithChildren<{
  defaultClosed?: boolean;
  renderControls?: () => ReactElement;
  titleKey: string;
  toggleable?: boolean;
}>;

const SectionWithBanner = ({
  children,
  defaultClosed = false,
  renderControls,
  titleKey,
  toggleable = false
}: Props) => {
  const intl = useIntl();
  const [displayContent, setDisplayContent] = useState<boolean>(!defaultClosed);

  const toggleDisplay = useCallback(() => {
    setDisplayContent(!displayContent);
  }, [displayContent]);

  return (
    <>
      <div className={styles.sectionBanner}>
        <IonGrid className={'ion-no-padding ' + styles.header}>
          <IonRow className="ion-no-padding">
            <IonCol className={'ion-no-padding ' + styles.title}>
              <Heading2>{intl.formatMessage({ id: titleKey })}</Heading2>
            </IonCol>
            {toggleable && (
              <IonCol className="align-right">
                <TertiaryButton
                  data-test="toggle-display"
                  icon={displayContent ? 'chevronUp' : 'chevronDown'}
                  onClick={toggleDisplay}
                  onKeyUp={clickCurrentTarget}
                  tabIndex={0}
                  textKey={displayContent ? 'dictionary.hide' : 'dictionary.show'}
                />
              </IonCol>
            )}
            {renderControls && (
              <>
                <IonCol className="align-right" size="auto">
                  {renderControls()}
                </IonCol>
              </>
            )}
          </IonRow>
        </IonGrid>
      </div>
      <div className={styles.children}>{(!toggleable || displayContent) && <>{children}</>}</div>
    </>
  );
};

export default SectionWithBanner;
